import classNames from "classnames";
import Switch from "../Switch";

const Categories = ({
  productCategories,
  activeCategory,
  activeSubCategory,
  setActiveCategory,
  setActiveSubCategory,
}: any) => {
  const handleCategoryClick = (sub: any) => {
    setActiveSubCategory(sub);
  };

  const handleMainCategoryClick = (category: string) => {
    setActiveCategory(category);
    setActiveSubCategory("");
  };

  const CatItem = ({ i }: any) => {
    return (
      <>
        <button
          className={classNames(
            "flex items-center gap-2 mb-2 font-bold hover:text-primaryred",
            {
              "text-primaryred": activeCategory === i.category && !activeSubCategory
            }
          )}
          onClick={() => handleMainCategoryClick(i.category)}
        >
          {i.category}
        </button>
        <div className="mb-5">
          {i.sub.map((sub: any, index: any) => (
            <button
              key={index}
              className={classNames(
                "block pl-2 py-1 border-l hover:font-bold",
                {
                  "border-gray-300 text-[#5c5c5c]": activeSubCategory !== sub,
                  "border-primaryred font-bold text-gray-600":
                    activeSubCategory === sub,
                }
              )}
              onClick={() => handleCategoryClick(sub)}
            >
              {sub}
            </button>
          ))}
          <button 
            className="block pl-2 py-1 border-l border-gray-300 hover:font-bold text-[#5c5c5c]"
            onClick={() => {
              setActiveSubCategory("");
              setActiveCategory(i.category);
            }}
          >
            Shop All {i.category}
          </button>
        </div>
      </>
    );
  };

  return (
    <>
      {/* <div className="flex items-center justify-between">
        <div className="text-[#5c5c5c]">No Minimum Quantity</div>
        <Switch onChange={() => {}} />
      </div>
      <div className="flex items-center justify-between -mt-4">
        <div className="text-[#5c5c5c]">Fast Shopping Options Only</div>
        <Switch onChange={() => {}} />
      </div> */}
      <button
        className="mb-2 text-lg font-bold uppercase"
        onClick={() => {
          setActiveCategory("");
          setActiveSubCategory("");
        }}
      >
        All Products
      </button>
      <div>
        {productCategories.map((i: any, index: any) => (
          <div key={index}>
            <CatItem i={i} />
          </div>
        ))}
      </div>
    </>
  );
};

export default Categories;
